import { $, $$ } from "@/utilities/helpers";

export class Menu {
    constructor(element) {
        this.element = element;
        this.navLinks = this.element.querySelectorAll(".navigation__link");
        this.indicator = this.element.querySelector(".navigation__indicator");

        this.init();
    }

    init() {
        this._handleMenuLinkClick();
        this._sectionInViewWatcher();
        this._shiftIndicator(this.navLinks[0]);

        window.addEventListener("resize", () => {
            this._handleResize();
        });
    }

    _handleMenuLinkClick() {
        this.navLinks.forEach((link) => {
            link.addEventListener("click", (event) => {
                event.preventDefault();

                this.navLinks.forEach((link) => {
                    link.classList.remove("active");
                });
                event.target.classList.add("active");

                let targetSelector = this._getIdFromLink(event.target);
                if (!targetSelector) {
                    console.error("No target selector found.");
                    return;
                }

                const targetElement = document.querySelector(targetSelector);
                if (!targetElement) {
                    console.error(`Target element ${target} not found.`);
                    return;
                }

                targetElement.scrollIntoView({
                    behavior: "smooth",
                    block: "start",
                });

                this._shiftIndicator(event.target);
            });
        });
    }

    _getIdFromLink(link) {
        const href = link.getAttribute("href");
        const hashIndex = href.indexOf("#");

        if (hashIndex !== -1) {
            return href.substring(hashIndex);
        }
        return null;
    }

    _sectionInViewWatcher() {
        const sections = document.querySelectorAll(".slide");

        const options = {
            root: null,
            rootMargin: "-15% 0px",
        }

        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    const id = entry.target.getAttribute("id");

                    if (entry.target === sections[0]) {
                        this._shiftIndicator(this.navLinks[0]);
                    } else {
                        this.navLinks.forEach((link) => {
                            const linkId = this._getIdFromLink(link);

                            if (linkId == `#${id}`) {
                                this.navLinks.forEach((link) => link.classList.remove("active"));
                                link.classList.add("active");
                                this._shiftIndicator(link);
                            }
                        });
                    }
                }
            });
        }, options);

        sections.forEach((section) => {
            observer.observe(section);
        });
    }

    _shiftIndicator(link) {
        // get the parent of the link - the navigation
        const navigation = document.querySelector(".navigation");
        const navigationRect = navigation.getBoundingClientRect();

        // get the link rect
        const linkRect = link.getBoundingClientRect();

        // get the indicator rect
        const indicatorRect = this.indicator.getBoundingClientRect();

        // get the offset of the link
        const offset = linkRect.left - navigationRect.left;
        const offsetMiddle = offset + linkRect.width / 2 - indicatorRect.width / 2;

        // set the indicator left to the offset
        this.indicator.style.left = `${offsetMiddle}px`;
    }

    // Prevents the indicator from having left: 0px on resize
    // Mobile menu will set active class on the link
    _handleResize() {
        const activeLink = this.element.querySelector(".navigation__link.active");
        if (activeLink) {
            this._shiftIndicator(activeLink);
        }
    }
}